import styled from 'styled-components';

const Price = styled.div`
  padding: ${({ theme }) => theme.constants.lateralSpace};

  .discounts {
    display: flex;
    flex-direction: row;
    font-family: ${({ theme }) => theme.fonts.primaryFont};
    font-size: 14px;
    line-height: 28px;
    color: ${props => props.theme.colors.textSecondary};
    padding-bottom: 12px;
  }

  .subtotal {
    display: flex;
    flex-direction: row;
    ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
    line-height: 20px;
    color: ${props => props.theme.colors.textSecondary};
  }

  & .format {
    .left {
      flex: 4;
    }

    .right {
      text-align: right;
      flex: 1;
      padding-right: 5%;
    }
  }
`;

export default Price;
